import { Container, Divider, Grid, TextField } from '@material-ui/core'
import React, { useContext } from 'react'
import FlexView from 'react-flexview/lib'
import { useForm } from 'react-hook-form'
import adminApi from '../../api/admin.api'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { awaitWithLoading } from '../../services/utils'
import NewFillButton from '../Core/NewFillButton'
import { ProfilePicturePopover } from '../Core/Popover/ProfilePicturePopover'
import { SkyElementHoverPopover } from '../Core/Popover/SkyPopover'
import { ReactComponent as CompanyLogoSvg } from '../../assets/company-logo.svg';
import { ReactComponent as CameraIconSvg } from '../../assets/camera_add.svg';
import { ReactComponent as CameraChangeSvg } from '../../assets/change-photo.svg';
import './CreatePartnershipForm.scss'
import { ErrorSharp, SignalCellularNoSimOutlined } from '@material-ui/icons'
import { EMAIL_REGEX } from '../../Constants'
import { useHistory } from 'react-router'
import { AdminContextStore } from './AdminContext'

export const AssignAgentForm = () => {
    const adminContext = useContext(AdminContextStore)
    const history = useHistory()
    const {register, errors, getValues, setValue, watch, triggerValidation} = useForm({mode: 'onChange', defaultValues: {
        partnership_code: history.location.state ? history.location.state.partnership_code ?? "" : ""
    }})
    
    const submit = async () => {
        let valid = await triggerValidation()
        
        if(!valid) return

        var form = getValues()

        let res = await awaitWithLoading(adminApi.assignAgent(getValues())) 
        if(res.ok) {
            EventEmitterService.dispatch(EventKey.ShowSuccess, {title: "Agent Assigned!",
                     body: "An agent successfully assigned to an agency"})
            
            adminContext.loadAgencies()
        }
        else 
            EventEmitterService.dispatch(EventKey.ShowError, res)
    }

    return (<Container className='margin-top-basic'>
        <div className="text-promotion black bold">Assign an Agent</div> 

        <br />

        <br />
        <div className="text-title blue bold">Agent Details</div> 
        <Divider />
        <br />

        <Grid container spacing={3}>
            <Grid item xs={12} sm={4}> 
                <TextField name="user_email" label={"Email"} error={!!errors.user_email} fullWidth variant="outlined" type="email" inputRef={register({required: true, pattern: { value: EMAIL_REGEX, message: "Invalid email address"} })}  helperText={!!errors.user_email && (errors.user_email.message || errors.user_email.type)}/>
            </Grid>
        </Grid>
        <br />
        <div className="text-title blue bold">Agency Details</div> 
        <Divider />
        <br />
        <Grid container spacing={3}>
            <Grid item xs={12} sm={4}> 
                <TextField inputRef={register({required: true})} name="partnership_code" label={"Agency Code (Short Name)"} error={!!errors.partnership_code} helperText={!!errors.partnership_code ? 'required' : 'for example: ajg, aon, costero'} fullWidth variant="outlined" />
            </Grid>
        </Grid>
        <FlexView hAlignContent='left'>
            <NewFillButton onClick={submit} flat green>Submit</NewFillButton>
        </FlexView>

    </Container>)
}